import * as React from "react";
import { SVGProps } from "react";

interface ScanCodePromoProps extends SVGProps<SVGSVGElement> {
    width?: string;
    height?: string;
}

export const ScanCodePromo = (props: ScanCodePromoProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? 28}
        height={props.height ?? 28}
        viewBox="0 0 28 28"
        {...props}
    >
        <path
            id="Trac\xE9_22577"
            data-name="Trac\xE9 22577"
            d="M119,76a1,1,0,0,1,0,2h-3a1,1,0,0,0-1,1v2.5a1,1,0,0,1-2,0V79a3,3,0,0,1,3-3Zm16,2a1,1,0,0,1,0-2h3a3,3,0,0,1,3,3v2.5a1,1,0,0,1-2,0V79a1,1,0,0,0-1-1Zm-3,3a1,1,0,0,1,0-2h3a3,3,0,0,1,3,3v6a1,1,0,0,1-2,0V82a1,1,0,0,0-1-1Zm-7,10a1,1,0,0,1,0,2h-6a1,1,0,0,0-1,1v6a1,1,0,0,1-2,0V94a3,3,0,0,1,3-3Zm9-8a1,1,0,0,1,0,2h-3a1,1,0,0,0-1,1v2a1,1,0,0,1-2,0V86a3,3,0,0,1,3-3Zm-14,18a1,1,0,0,1,0-2h5a1,1,0,0,1,0,2Zm-1,1a1,1,0,0,1,0,2h-3a3,3,0,0,1-3-3V98.5a1,1,0,0,1,2,0V101a1,1,0,0,0,1,1Zm16,2a1,1,0,0,1,0-2h3a1,1,0,0,0,1-1V98.5a1,1,0,0,1,2,0V101a3,3,0,0,1-3,3Zm-9-22v4a3,3,0,0,1-3,3h-4a3,3,0,0,1-3-3V82a3,3,0,0,1,3-3h4A3,3,0,0,1,126,82Zm-2,0a1,1,0,0,0-1-1h-4a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1Zm14,12v4a3,3,0,0,1-3,3h-4a3,3,0,0,1-3-3V94a3,3,0,0,1,3-3h4A3,3,0,0,1,138,94Zm-2,0a1,1,0,0,0-1-1h-4a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1Zm-13.5,0a2,2,0,1,1-2,2A2,2,0,0,1,122.5,94Z"
            transform="translate(-113 -76)"
            fill="#141414"
            fillRule="evenodd"
        />
    </svg>
);
